import React from 'react';

import { type LinkKind, classifyLink } from '@sola/utils/url.ts';

/**
 * Destinations we own, and so are willing to turn into a real link here.
 * Anything else in author-supplied form copy degrades to plain text.
 */
const linkableKinds = new Set<LinkKind>([
  'current-app-path',
  'legacy-path',
  'sola-app',
]);

export const parseInlineLinks = (text: string): React.ReactNode => {
  // eslint-disable-next-line sonarjs/slow-regex
  const linkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = linkPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const [, linkText, rawUrl] = match;
    const { kind, target, url } = classifyLink(rawUrl);
    parts.push(
      linkableKinds.has(kind) ? (
        <a
          key={match.index}
          href={url}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        >
          {linkText}
        </a>
      ) : (
        linkText
      ),
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  if (parts.length === 0) {
    return text;
  }

  return <>{parts}</>;
};
